<h1 mat-dialog-title>{{data.title | translate}}</h1>
<div mat-dialog-content>
  <form-field
    class="tw-w-full"
    label="data.message"
    [(value)]="data.name"
  >
  </form-field>
</div>
<div mat-dialog-actions>
  <button
    class="btn"
    [themeColor]="'btn'"
    mat-button
    mat-dialog-close
    cdkFocusInitial
    [mat-dialog-close]="data.name"
  >
    {{'common.submit' | translate}}
  </button>
  <button class="btn" [themeColor]="'cancel-btn'" mat-button mat-dialog-close>
    {{'common.cancel' | translate}}
  </button>
</div>
